import { PLAN_IDS, type PlanIdValue, type LegalContentSlug } from '@fluenceur/types';

// Re-export for convenience
export { PLAN_IDS };
export type PlanId = PlanIdValue;

/**
 * Get the external URL for a legal document as fallback
 */
export function getLegalContentExternalUrl(slug: LegalContentSlug): string {
  const baseUrl = import.meta.env.VITE_PAYLOAD_URL || 'https://fluenceur.com';
  return `${baseUrl}/${slug}`;
}
